export enum ImportType {
  PARTS_COSTS = 'partsCosts',
  UOMS = 'uoms',
  VENDOR_COST = 'vendorCosts',
  PART_ATTRIBUTES = 'partAttributes',
}
